import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { SMLSettingsTabId } from '../../modules/settings/tabs/types';
import { SMLRouteNames } from './SMLRoutes';

const SETTINGS_TAB_IDS: ReadonlySet<string> = new Set(Object.values(SMLSettingsTabId));

/**
 * Sends an old page to its Settings tab (design artist-settings a1, b1): the old Edit Profile
 * page (/app/account) goes to Settings → Artist, the old Manage Trackers pages (/app/trackers)
 * go to Settings → SmartLinks. Old links and bookmarks keep working.
 */
export const SettingsTabRedirect: React.FC<{ tab: SMLSettingsTabId | 'artist' | 'smartlinks' }> = ({ tab }) => (
  <Navigate to={{ pathname: `/${SMLRouteNames.settings}`, search: `?tab=${tab}` }} replace />
);

/**
 * A Settings tab written as a path (`/app/settings/artist`) goes to the same tab as a query
 * (`/app/settings?tab=artist`). The Settings page reads only the query, so the path showed an
 * empty page. A path that names no tab opens Settings.
 */
export const SettingsPathTabRedirect: React.FC = () => {
  const { tab } = useParams<{ tab: string }>();
  const search = tab !== undefined && SETTINGS_TAB_IDS.has(tab) ? `?tab=${tab}` : '';
  return <Navigate to={{ pathname: `/${SMLRouteNames.settings}`, search }} replace />;
};
